import {createContext, ReactNode, useContext} from 'react';
import {getBackendUrl} from 'utilities';
import {useMediaCreate} from 'views/news/hooks';

export const RICH_TEXT_MEDIA_UPLOAD_SIZE_LIMIT_BYTES = 6 * 1024 * 1024;

export type RichTextMediaUpload = {
  uploadMedia: ({path, file}: {path: string; file: File}) => Promise<string>;
  getMediaUrl: (asset: string) => string;
  maxFileSizeBytes?: number;
};

const MediaUploadContext = createContext<RichTextMediaUpload | undefined>(undefined);

export const MediaUploadProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value?: RichTextMediaUpload;
}) => <MediaUploadContext.Provider value={value}>{children}</MediaUploadContext.Provider>;

export const useRichTextMediaUpload = () => {
  const scopedMediaUpload = useContext(MediaUploadContext);
  const {uploadMedia} = useMediaCreate();

  return (
    scopedMediaUpload ?? {
      uploadMedia,
      getMediaUrl: (asset: string) => `${getBackendUrl()}/api/v1/news/media/${asset}`,
      maxFileSizeBytes: RICH_TEXT_MEDIA_UPLOAD_SIZE_LIMIT_BYTES,
    }
  );
};
